import companyLogo from '../Images/online-adda-logo.png';
import { Link } from 'react-router-dom';

function NavBar()
{

    return (
        <div className="w-full  bg-violet-900">
            <div className="md:container lg:max-w-[90%] mx-auto flex justify-between lg:flex-row flex-col">
               
               <div className="relative flex  w-full md:w-fit ">
                    <div className="hidden lg:block w-[60px] h-full  absolute z-10 left-0" id="gradient-background1"></div>
                    <img className="overflow-hidden lg:w-[250px]" src={companyLogo} alt="Logo" />
                    <div className="hidden lg:block w-[70px] h-full  absolute z-10 right-0" id="gradient-background2"></div>
               </div>

                <ul className="flex items-center pl-3 pr-3  w-[100vw] lg:w-fit  justify-center text-center font-bold text-white ">
                    <Link to="/" className=''>
                    <div className="hover:cursor-pointer  hover:bg-violet-950 h-full flex items-center md:p-4 p-1 active:text-gray-400">
                        <li className="text-sm md:text-xl  ">Home</li>
                    </div>   
                    </Link>  

                    <Link to="/Electronics">
                    <div className="hover:cursor-pointer hover:bg-violet-950 h-full flex items-center md:p-4 p-1 active:text-gray-400">
                        <li className="md:text-xl text-sm">Electronics</li>
                    </div>  
                    </Link>


                    <Link to="/Jewellery">
                    <div className="hover:cursor-pointer hover:bg-violet-950 h-full flex items-center md:p-4 p-1 active:text-gray-400">
                        <li className="md:text-xl text-sm">Jewellery</li>
                    </div>  
                    </Link>

                    <Link to="/Mens">
                    <div className="hover:cursor-pointer hover:bg-violet-950 h-full flex items-center md:p-4 p-1 active:text-gray-400">
                        <li className=" md:text-xl text-sm">Men's clothing</li>
                    </div>  
                    </Link>


                    <Link to="/Womens">
                    <div className="hover:cursor-pointer hover:bg-violet-950 h-full flex items-center md:p-4 p-1 active:text-gray-400">
                        <li className="md:text-xl text-sm">Women's clothing</li>
                    </div>     
                    </Link>  

                </ul>
            </div>
        </div>
    );
}

export default NavBar;

// "electronics",
// "jewellery",
// "men's clothing",
// "women's clothing"